export const fontFamilies = {
  roboto: "Roboto, NotoSans, Sans-Serif"
};
